import React from "react";
import {observer, inject} from "mobx-react";
import queryString from "query-string";
import paginator from "@components/Pagination/paginator";
import axios from "axios";

@inject("store")
@observer
export default class CustomerOrderCopies extends React.Component {


    constructor(props) {
        super(props);
        this.update = this.update.bind(this);
        this.changePage = this.changePage.bind(this);
        this.buildPagination = this.buildPagination.bind(this);
        this.getDocumentUrl = this.getDocumentUrl.bind(this);
        this.state = {
            orderHeads: null,
            columnDataTypes: [],
            totalfound: 0,
            itemsperpage: 50,
            currentpage: 1,
            orderGuid: null,
            orders: [],
            openOrders: [],
            currency: "",
            currencyCode :""
        };

    }


    componentDidMount() {
        this.update();
    }

    componentDidUpdate(prevProps, prevState) {

        const navigation = this.props.store.navigation;
        const query = navigation.getParsedQueryString();
        
        if (query && query.currentpage && this.state.currentpage !== parseInt(query.currentpage)) {
            this.setState({currentpage: query.currentpage});
        } else if (query && query.OrderGuid && this.state.orderGuid !== query.OrderGuid) {
            this.setState({orderGuid: query.OrderGuid});
        } else if (prevState.currentpage !== this.state.currentpage) {
            this.update();
        }
    }


    componentWillUnmount() {
        if (typeof this._source != typeof undefined) {
            this._source.cancel('Operation canceled due to component unmount.');

        }
    }

    update() {
        if (typeof this._source != typeof undefined) {
            this._source.cancel('Operation canceled due to new request.');
        }

        this._source = axios.CancelToken.source();
        this.props.store.reports.getOrderCopies(this.state.currentpage, this._source.token).then(
            result => {
                this.setState({
                    rows: result.data.Rows,
                    columnDataTypes: result.columns,
                    totalfound: result.totalfound,
                    itemsperpage: result.itemsperpage,
                    currentpage: result.currentpage,
                    currency: result.currency,
                    currencyCode: result.currencyCode
                });
            },
            error => {
                if (!axios.isCancel(error)) {
                    console.error("getOrderCopies, an error occured", error);
                }
            });

        if (this.state.OrderGuid) {
            this.props.store.reports.getOrderDocumentUrl("OrderCopy", this.state.orderGuid).then(result => {
                this.setState({content: result.content});
            });
        }
    }

    updateQuery(queryParameters) {
        const newQuery = {...this.props.store.navigation.getParsedQueryString(), ...queryParameters};
        this.props.store.navigation.navigateToSiteUrl(null, null, null, null, queryString.stringify(newQuery));
    }

    changePage(e, page) {
        e.preventDefault();
        this.updateQuery({currentpage: page});
        //this.setState({ currentpage: page });
    }

    formatDate(date) {
        if (date === null) {
            return "";
        }
        return new Intl.DateTimeFormat('en-GB',
            {
                //year: 'numeric', 
                //month: 'long', 
                //day: '2-digit' 

            }).format(Date.parse(date));
    }

    formatNumber() {
    }


    formatMoney(value) {
        return value.toFixed(2);
        //return new Intl.NumberFormat('en-GB',
        //	{
        //		style: 'currency',
        //		//currency: 'GBP',
        //		minimumFractionDigits: 0,
        //		maximumFractionDigits: 0
        //	}).format(value);
    }

    setupColumns(row0, columnsDataType) {
        let config = [];
        const columns = Object.keys(row0);
        // [column: { name:"", classes:"" }]
        config = columns.map((fieldName, index) => {
            const dataType = columnsDataType[fieldName];
            let classes = [];

            switch (dataType) {
                case "Decimal":
                    classes.push("text-right");
                    break;
            }

            switch (fieldName) {
                case "OrderNumber":
                    classes.push("text-medium");
                    break;
                case "TotalSum":
                    break;
                default:
                    classes.push("ellips");
                //classNames = [];
            }
            const classNames = classes.join(" ");

            return {name: fieldName, dataType: dataType, classNames: classNames}
        });


        return config;
    }


    formatField(value, dataType) {
        switch (dataType) {

            case "DateTime":
                return this.formatDate(value);

            case "Decimal":
                return this.formatMoney(value);
            default:
                return value;
        }
    }


    buildPagination() {


        const paginationInfo = new paginator(
            this.state.itemsperpage,
            7
        ).build(this.state.totalfound, this.state.currentpage);
        const pages = [];
        for (
            let i = paginationInfo.first_page;
            i <= paginationInfo.last_page;
            i++
        ) {
            pages.push(
                <li
                    key={i + ""}
                    className={i === paginationInfo.current_page ? "active" : ""}
                >
                    <a href="#"
                       onClick={(e) => {
                           this.changePage(e, i);
                       }}
                    >{i + ""}</a>
                </li>
            );
        }


        return (
            <nav className="pagination">
                <div className="column">
                    <ul className="pages">
                        {1 !== paginationInfo.current_page && paginationInfo.first_page > 1
                            ? <React.Fragment>
                                <li><a href="#" onClick={(e) => {
                                    this.changePage(e, 1);
                                }}>1</a></li>
                                <li>...</li>
                            </React.Fragment>
                            : null}
                        {pages}
                        {paginationInfo.total_pages !== paginationInfo.current_page &&
                        paginationInfo.last_page < paginationInfo.total_pages
                            ? <React.Fragment>
                                <li>...</li>
                                <li><a href="#" onClick={(e) => {
                                    this.changePage(e, paginationInfo.total_pages);
                                }}>{paginationInfo.total_pages}</a></li>

                            </React.Fragment>
                            : null}


                    </ul>
                </div>

            </nav>);
    }


    toggleOrderCopy(e, orderGuid) {
        e.preventDefault();
        if (typeof this._source != typeof undefined) {
            this._source.cancel('Operation canceled due to new request.');
        }

        this._source = axios.CancelToken.source();

        var index = this.state.orders.findIndex(x => x.OrderGuid === orderGuid);

        if (index === -1) {
            this.props.store.reports.getOrderCopy(orderGuid, this._source.token).then(result => {
                this.setState(prevState => ({
                    orders: [...prevState.orders, result],
                    openOrders: [...prevState.openOrders, orderGuid]
                }))
            });
        } else {
            if (this.state.openOrders.findIndex(x => x === orderGuid) > -1) {
                this.setState((prevState) => ({
                    openOrders: prevState.openOrders.filter(x => x !== orderGuid)
                }));
            } else {
                this.setState(prevState => ({
                    openOrders: [...prevState.openOrders, orderGuid]
                }))
            }
        }
    }


    getDocumentUrl(e, orderGuid) {
        e.preventDefault();
        if (typeof this._source != typeof undefined) {
            this._source.cancel('Operation canceled due to new request.');
        }

        this._source = axios.CancelToken.source();
        this.props.store.reports.getOrderDocumentUrl("OrderCopy", orderGuid, this._source.token).then(result => {
            var win = window.open(result.url, '_blank');
            win.focus();
        });
    }


    render() {

        const navigation = this.props.store.navigation;


        if (!this.props.store.navigation.getCustomerId()) {
            return <div>Error: No customer chosen</div>;
        }

        if (!this.state.rows) {
            return <div>Laddar...</div>;
        }

        if (this.state.rows.length === 0) {
            return <div><strong>Hittar inga order.!</strong></div>;
        }

        const pagination = this.buildPagination();

        return (
            <div className={"customer-order-copies"}>

                <h4 className="text-normal pt-4">Orderlista</h4>
                <hr className="mb-3"/>

                <div className={"row my-2 "}>
                    <div className={"col-3 hidden-sm-down"}>
                        <strong>Orderdatum</strong>
                    </div>
                    <div className={"col-6 col-md-3"}>
                        <strong>Ordernummer</strong>
                    </div>
                    <div className={"col-6 col-md-3 text-right"}>
                        <strong>Totalt</strong>
                    </div>
                </div>


                {this.state.rows.map(row => {

                    const order = this.state.openOrders.indexOf(row["OrderGuid"]) > -1 ? this.state.orders.find(x => x.OrderGuid === row["OrderGuid"]) : null;


                    return (
                        <div className="row"
                             key={row["OrderNr"]}

                        >
                            <div className="col-12"
                                 style={{cursor: "pointer"}}
                                 onClick={(e) => {
                                     this.toggleOrderCopy(e, row["OrderGuid"])
                                 }
                                 }
                            >
                                <div className={"row my-2 "}>
                                    <div className={"col-3 hidden-md-down"}>
                                        <strong>{row["RegistrationDate"]}</strong>
                                    </div>
                                    <div className={"col-6 col-md-3"}>
                                        <strong>{row["OrderNr"]}</strong>
                                    </div>
                                    <div className={"col-6 col-md-3 text-right"}>
                                        <strong>{this.formatMoney(row["OrderTotal"])} {this.state.currency}</strong>
                                    </div>
                                </div>

                                {/*<div className="text-xxs">*/}
                                {/*    {row["RegistrationDate"] ? <span>Registered: {row["RegistrationDate"]}</span> : row["CheckedOutInProcessDate"] ? <span>Committed: {row["CheckedOutInProcessDate"]}</span> : null}{row["Origin"] ?*/}
                                {/*    <span>, Origin: {row["Origin"]}</span> : null} , <span title={row["OrderStatusId"]}>Status: {row["OrderStatus"]}</span>*/}
                                {/*</div>*/}
                                <hr/>
                            </div>
                            {order
                                ? <div className="col-12">
                                    <div className="propertyPane leftAligned shippingPane ng-scope">
                                        <h4>Order {order.OrderNumber}</h4>
                                        <div className="">
                                            <div className={"row"}>
                                                <div className="col-sm-4 col-md-6">
                                                    <legend>
                                                        Orderadress
                                                    </legend>
                                                    <div className={"mb-2"}>
                                                        <div>{order.BillingAddress.FirstName} {order.BillingAddress.LastName}</div>
                                                        <div>{order.BillingAddress.Line1}</div>
                                                        <div>{order.BillingAddress.PostalCode} {order.BillingAddress.City}</div>
                                                        <div></div>
                                                        <div>{order.BillingAddress.CountryName}</div>
                                                        <div></div>
                                                        <div></div>
                                                        <div>{order.BillingAddress.EmailAddress}</div>
                                                        <div></div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-4 col-md-6">
                                                    <legend>
                                                        Leveransadress
                                                    </legend>
                                                    <div className={"mb-2"}>
                                                        <div>{order.ShippingAddress.FirstName} {order.ShippingAddress.LastName}</div>
                                                        <div>{order.ShippingAddress.Line1}</div>
                                                        <div>{order.ShippingAddress.PostalCode} {order.ShippingAddress.City}</div>
                                                        <div></div>
                                                        <div>{order.ShippingAddress.CountryName}</div>
                                                        <div></div>
                                                        <div></div>
                                                        <div>{order.ShippingAddress.EmailAddress}</div>
                                                        <div></div>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-6">
                                                    <legend>Orderdetaljer</legend>
                                                    <div className={"order-copy-properties mb-2"}>
                                                        <div>
                                                            <span className="">Ordernummer</span>
                                                            <span>{order.OrderNumber}</span>
                                                        </div>
                                                        <div>
                                                            <span>Status</span>
                                                            <span>{order.OrderStatus}</span>
                                                        </div>
                                                        <div>
                                                            <span>Skapad</span>
                                                            <span>{order.CreatedDate}</span>
                                                        </div>
                                                        <div>
                                                            <span>Slutförd</span>
                                                            <span>{order.CompletedDate}</span>
                                                        </div>
                                                        <div>
                                                            <span>Valuta</span>
                                                            <span>{order.CurrencyCode}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                {order.Note 
                                                    ? <div className="col-sm-12 col-md-6">
                                                        <legend>Meddelande</legend>
                                                        <div className={"order-copy-properties mb-2"}>
                                                            <div>
                                                                {order.Note}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    : null}
                                            </div>
                                            <legend>Orderrader</legend>
                                            <div className={"table-responsive-sm"}>
                                                <table className="table">
                                                    <thead>
                                                    <tr>
                                                        <th><span>Art. nr</span></th>
                                                        <th><span>Beskrivning</span></th>
                                                        <th className="text-sm-right text-nowrap"><span>Pris</span></th>
                                                        {/*<th><span>Moms</span></th>*/}
                                                        <th className="text-sm-right text-nowrap"><span>Antal</span></th>
                                                        <th className="text-sm-right text-nowrap"><span>Total</span></th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    {order.ProductList.flatMap(pl => pl.OrderLines).sort((a,b) => a.Sku.localeCompare(b.Sku)).map(ol => {

                                                        return (
                                                            <tr key={ol.OrderLineId}>
                                                                <td><span>{ol.VariantSku || ol.Sku}</span></td>
                                                                <td><span>{ol.Name}</span></td>
                                                                <td className={"text-sm-right text-nowrap"}><span>{ol.PriceExFormatted} {order.Currency}</span></td>
                                                                {/*<td><span>3,46 kr</span></td>*/}
                                                                <td className={"text-sm-right text-nowrap"}><span>{ol.Quantity}</span></td>
                                                                <td className={"text-sm-right text-nowrap"}><span>{ol.TotalExFormatted} {order.Currency}</span></td>
                                                            </tr>
                                                        );
                                                    })}

                                                    </tbody>
                                                    <tfoot>
                                                    <tr>
                                                        <td className="text-sm-right text-nowrap" colSpan="4"><span>Radtotal</span></td>
                                                        <td className="text-sm-right text-nowrap">{order.SubTotalFormatted} {order.Currency}</td>
                                                    </tr>
                                                    <tr>
                                                        <td className="text-sm-right text-nowrap" colSpan="4"><span>Moms</span></td>
                                                        <td className="text-sm-right text-nowrap">{order.TaxTotalFormatted} {order.Currency}</td>
                                                    </tr>

                                                    <tr>
                                                        <td className="text-sm-right text-nowrap" colSpan="4"><span>Leveranskostnad</span></td>
                                                        <td className="text-sm-right text-nowrap">{order.ShippingTotalFormatted} {order.Currency}</td>
                                                    </tr>

                                                    {order.DiscountTotal > 0
                                                        ? <tr>
                                                            <td className="text-sm-right text-nowrap" colSpan="4"><span>Rabatter</span></td>
                                                            <td className="text-sm-right text-nowrap">{order.DiscountTotalFormatted} {order.Currency}</td>
                                                        </tr>
                                                        : null
                                                    }
                                                    <tr>
                                                        <td className="text-sm-right text-nowrap" colSpan="4"><span>Ordertotal</span></td>
                                                        <td className="text-sm-right text-nowrap">{order.OrderTotalFormatted} {order.Currency}</td>
                                                    </tr>
                                                    </tfoot>
                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                : null}
                        </div>
                    );

                })}
                {pagination}
            </div>);

    }
}